import { render, staticRenderFns } from "./LmInbox.vue?vue&type=template&id=267e2d26&scoped=true"
import script from "./LmInbox.vue?vue&type=script&lang=js"
export * from "./LmInbox.vue?vue&type=script&lang=js"
import style0 from "./LmInbox.vue?vue&type=style&index=0&id=267e2d26&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e2d26",
  null
  
)

export default component.exports